/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectResponseDashboardDto } from '../../models/project-response-dashboard-dto';

export interface DashboardProjectsControllerListProjectsV1$Params {

/**
 * Page number (default: 1)
 */
  page?: number;

/**
 * Items per page (default: 20, max: 100)
 */
  limit?: number;

/**
 * Search term for filtering by project name
 */
  search?: string;
}

export function dashboardProjectsControllerListProjectsV1(http: HttpClient, rootUrl: string, params?: DashboardProjectsControllerListProjectsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'projects'?: Array<ProjectResponseDashboardDto>;
'total'?: number;
'page'?: number;
'pages'?: number;
}>> {
  const rb = new RequestBuilder(rootUrl, dashboardProjectsControllerListProjectsV1.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'projects'?: Array<ProjectResponseDashboardDto>;
      'total'?: number;
      'page'?: number;
      'pages'?: number;
      }>;
    })
  );
}

dashboardProjectsControllerListProjectsV1.PATH = '/v1/dashboard/projects';
